import { createAction, props } from "@ngrx/store";
import { Result } from '../../shared/models/core/result.model';
import { Lcca } from '../../shared/models/common/lcca.model';
import { Road } from '../../shared/models/common/road.model';
import { Bound } from '../../shared/models/common/bound.model';
import { Zone } from '../../shared/models/common/zone.model';
import { AssetCode } from '../../shared/models/common/asset-code.model';
import { CatalogAssetCodesGroupDistinctCreate, CatalogAssetCodesGroupDistinctResponse, CatalogAssetCodesGroupDistinctUpdate } from '../../shared/models/common/asset-codes-group-distinct.model';
import { CatalogLccaPeriodicalsCreate, CatalogLccaPeriodicalsResponse, CatalogLccaPeriodicalsUpdate } from '../../shared/models/common/lcca-periodical.model';
import { CatalogLccaTriggerCreate, CatalogLccaTriggerResponse, CatalogLccaTriggerUpdate } from '../../shared/models/common/lcca-trigger.model';
import { CatalogLccaTypeCreate, CatalogLccaTypeResponse, CatalogLccaTypeUpdate } from '../../shared/models/common/lcca-type-model';
import { CatalogLccaUnitCreate, CatalogLccaUnitResponse, CatalogLccaUnitUpdate } from '../../shared/models/common/lcca_unit.model';

export const findRoads = createAction(
  '[Common] Find Roads',
  props<{ page: number, size: number, keywords: string }>()
)

export const findRoadsSuccess = createAction(
  '[Common] Find Roads Success',
  props<{ roads: Result<Road> }>()
)

export const findRoadsError = createAction(
  '[Common] Find Roads Error',
  props<{ error: any }>()
)

// Create Road
export const createRoad = createAction(
  '[Common] Create Road',
  props<{ road: Road }>()
)

export const createRoadSuccess = createAction(
  '[Common] Create Road Success',
  props<{ road: Road }>()
)

export const createRoadError = createAction(
  '[Common] Create Road Error',
  props<{ error: any }>()
)

// Update Road
export const updateRoad = createAction(
  '[Common] Update Road',
  props<{ id: number, road: Road }>()
)

export const updateRoadSuccess = createAction(
  '[Common] Update Road Success',
  props<{ road: Road }>()
)

export const updateRoadError = createAction(
  '[Common] Update Road Error',
  props<{ error: any }>()
)

// Delete Road
export const deleteRoad = createAction(
  '[Common] Delete Road',
  props<{ id: number }>()
)

export const deleteRoadSuccess = createAction(
  '[Common] Delete Road Success',
  props<{ id: number }>()
)

export const deleteRoadError = createAction(
  '[Common] Delete Road Error',
  props<{ error: any }>()
)

///////// Bound /////////
export const findBounds = createAction(
  '[Common] Find Bounds',
  props<{ page: number, size: number, keywords: string }>()
)
export const findBoundsSuccess = createAction(
  '[Common] Find Bounds Success',
  props<{ bounds: Result<Bound> }>()
)
export const findBoundsError = createAction(
  '[Common] Find Bounds Error',
  props<{ error: any }>()
)
export const createBound = createAction(
  '[Common] Create Bound',
  props<{ bound: Bound }>()
)
export const createBoundSuccess = createAction(
  '[Common] Create Bound Success',
  props<{ bound: Bound }>()
)
export const createBoundError = createAction(
  '[Common] Create Bound Error',
  props<{ error: any }>()
)
export const updateBound = createAction(
  '[Common] Update Bound',
  props<{ id: number, bound: Bound }>()
)
export const updateBoundSuccess = createAction(
  '[Common] Update Bound Success',
  props<{ bound: Bound }>()
)
export const updateBoundError = createAction(
  '[Common] Update Bound Error',
  props<{ error: any }>()
)
export const deleteBound = createAction(
  '[Common] Delete Bound',
  props<{ id: number }>()
)
export const deleteBoundSuccess = createAction(
  '[Common] Delete Bound Success',
  props<{ id: number }>()
)
export const deleteBoundError = createAction(
  '[Common] Delete Bound Error',
  props<{ error: any }>()
)

///////// Zone /////////
export const findZones = createAction(
  '[Common] Find Zones',
  props<{ page: number, size: number, keywords: string }>()
)
export const findZonesSuccess = createAction(
  '[Common] Find Zones Success',
  props<{ zones: Result<Zone> }>()
)
export const findZonesError = createAction(
  '[Common] Find Zones Error',
  props<{ error: any }>()
)
export const createZone = createAction(
  '[Common] Create Zone',
  props<{ zone: Zone }>()
)
export const createZoneSuccess = createAction(
  '[Common] Create Zone Success',
  props<{ zone: Zone }>()
)
export const createZoneError = createAction(
  '[Common] Create Zone Error',
  props<{ error: any }>()
)
export const updateZone = createAction(
  '[Common] Update Zone',
  props<{ id: number, zone: Zone }>()
)
export const updateZoneSuccess = createAction(
  '[Common] Update Zone Success',
  props<{ zone: Zone }>()
)
export const updateZoneError = createAction(
  '[Common] Update Zone Error',
  props<{ error: any }>()
)
export const deleteZone = createAction(
  '[Common] Delete Zone',
  props<{ id: number }>()
)
export const deleteZoneSuccess = createAction(
  '[Common] Delete Zone Success',
  props<{ id: number }>()
)
export const deleteZoneError = createAction(
  '[Common] Delete Zone Error',
  props<{ error: any }>()
)

// Bulk Delete Road
export const bulkDeleteRoads = createAction(
  '[Common] Bulk Delete Roads',
  props<{ ids: number[] }>()
)
export const bulkDeleteRoadsSuccess = createAction(
  '[Common] Bulk Delete Roads Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteRoadsError = createAction(
  '[Common] Bulk Delete Roads Error',
  props<{ error: any }>()
)

// Bulk Delete Bound
export const bulkDeleteBounds = createAction(
  '[Common] Bulk Delete Bounds',
  props<{ ids: number[] }>()
)
export const bulkDeleteBoundsSuccess = createAction(
  '[Common] Bulk Delete Bounds Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteBoundsError = createAction(
  '[Common] Bulk Delete Bounds Error',
  props<{ error: any }>()
)

// Bulk Delete Zone
export const bulkDeleteZones = createAction(
  '[Common] Bulk Delete Zones',
  props<{ ids: number[] }>()
)
export const bulkDeleteZonesSuccess = createAction(
  '[Common] Bulk Delete Zones Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteZonesError = createAction(
  '[Common] Bulk Delete Zones Error',
  props<{ error: any }>()
)

///////// AssetCode /////////
export const findAssetCodes = createAction(
  '[Common] Find Asset Codes',
  props<{ page: number, size: number, keywords: string }>()
)
export const findAssetCodesSuccess = createAction(
  '[Common] Find Asset Codes Success',
  props<{ assetCodes: Result<AssetCode> }>()
)
export const findAssetCodesError = createAction(
  '[Common] Find Asset Codes Error',
  props<{ error: any }>()
)
export const createAssetCode = createAction(
  '[Common] Create Asset Code',
  props<{ assetCode: AssetCode }>()
)
export const createAssetCodeSuccess = createAction(
  '[Common] Create Asset Code Success',
  props<{ assetCode: AssetCode }>()
)
export const createAssetCodeError = createAction(
  '[Common] Create Asset Code Error',
  props<{ error: any }>()
)
export const updateAssetCode = createAction(
  '[Common] Update Asset Code',
  props<{ id: number, assetCode: AssetCode }>()
)
export const updateAssetCodeSuccess = createAction(
  '[Common] Update Asset Code Success',
  props<{ assetCode: AssetCode }>()
)
export const updateAssetCodeError = createAction(
  '[Common] Update Asset Code Error',
  props<{ error: any }>()
)
export const deleteAssetCode = createAction(
  '[Common] Delete Asset Code',
  props<{ id: number }>()
)
export const deleteAssetCodeSuccess = createAction(
  '[Common] Delete Asset Code Success',
  props<{ id: number }>()
)
export const deleteAssetCodeError = createAction(
  '[Common] Delete Asset Code Error',
  props<{ error: any }>()
)
export const bulkDeleteAssetCodes = createAction(
  '[Common] Bulk Delete Asset Codes',
  props<{ ids: number[] }>()
)
export const bulkDeleteAssetCodesSuccess = createAction(
  '[Common] Bulk Delete Asset Codes Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteAssetCodesError = createAction(
  '[Common] Bulk Delete Asset Codes Error',
  props<{ error: any }>()
)

///////// Life Cycle Cost Analysis /////////
export const findLccas = createAction(
  '[Common] Find LCCAs',
  props<{ page: number, size: number, keywords: string }>()
)
export const findLccasSuccess = createAction(
  '[Common] Find LCCAs Success',
  props<{ lccas: Result<Lcca> }>()
)
export const findLccasError = createAction(
  '[Common] Find LCCAs Error',
  props<{ error: any }>()
)
export const createLcca = createAction(
  '[Common] Create LCCA',
  props<{ lcca: Lcca }>()
)
export const createLccaSuccess = createAction(
  '[Common] Create LCCA Success',
  props<{ lcca: Lcca }>()
)
export const createLccaError = createAction(
  '[Common] Create LCCA Error',
  props<{ error: any }>()
)
export const updateLcca = createAction(
  '[Common] Update LCCA',
  props<{ id: number, lcca: Lcca }>()
)
export const updateLccaSuccess = createAction(
  '[Common] Update LCCA Success',
  props<{ lcca: Lcca }>()
)
export const updateLccaError = createAction(
  '[Common] Update LCCA Error',
  props<{ error: any }>()
)
export const deleteLcca = createAction(
  '[Common] Delete LCCA',
  props<{ id: number }>()
)
export const deleteLccaSuccess = createAction(
  '[Common] Delete LCCA Success',
  props<{ id: number }>()
)
export const deleteLccaError = createAction(
  '[Common] Delete LCCA Error',
  props<{ error: any }>()
)
export const bulkDeleteLccas = createAction(
  '[Common] Bulk Delete LCCAs',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccasSuccess = createAction(
  '[Common] Bulk Delete LCCAs Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccasError = createAction(
  '[Common] Bulk Delete LCCAs Error',
  props<{ error: any }>()
)

///////// AssetCodesGroupDistinct /////////
export const findAssetCodesGroupDistinct = createAction(
  '[Common] Find Asset Codes Group Distinct',
  props<{ page: number, size: number, keywords: string }>()
)
export const findAssetCodesGroupDistinctSuccess = createAction(
  '[Common] Find Asset Codes Group Distinct Success',
  props<{ assetCodesGroupDistinct: Result<CatalogAssetCodesGroupDistinctResponse> }>()
)
export const findAssetCodesGroupDistinctError = createAction(
  '[Common] Find Asset Codes Group Distinct Error',
  props<{ error: any }>()
)
export const createAssetCodesGroupDistinct = createAction(
  '[Common] Create Asset Codes Group Distinct',
  props<{ assetCodesGroupDistinct: CatalogAssetCodesGroupDistinctCreate }>()
)
export const createAssetCodesGroupDistinctSuccess = createAction(
  '[Common] Create Asset Codes Group Distinct Success',
  props<{ assetCodesGroupDistinct: CatalogAssetCodesGroupDistinctResponse }>()
)
export const createAssetCodesGroupDistinctError = createAction(
  '[Common] Create Asset Codes Group Distinct Error',
  props<{ error: any }>()
)
export const updateAssetCodesGroupDistinct = createAction(
  '[Common] Update Asset Codes Group Distinct',
  props<{ id: number, assetCodesGroupDistinct: CatalogAssetCodesGroupDistinctUpdate }>()
)
export const updateAssetCodesGroupDistinctSuccess = createAction(
  '[Common] Update Asset Codes Group Distinct Success',
  props<{ assetCodesGroupDistinct: CatalogAssetCodesGroupDistinctResponse }>()
)
export const updateAssetCodesGroupDistinctError = createAction(
  '[Common] Update Asset Codes Group Distinct Error',
  props<{ error: any }>()
)
export const deleteAssetCodesGroupDistinct = createAction(
  '[Common] Delete Asset Codes Group Distinct',
  props<{ id: number }>()
)
export const deleteAssetCodesGroupDistinctSuccess = createAction(
  '[Common] Delete Asset Codes Group Distinct Success',
  props<{ id: number }>()
)
export const deleteAssetCodesGroupDistinctError = createAction(
  '[Common] Delete Asset Codes Group Distinct Error',
  props<{ error: any }>()
)
export const bulkDeleteAssetCodesGroupDistinct = createAction(
  '[Common] Bulk Delete Asset Codes Group Distinct',
  props<{ ids: number[] }>()
)
export const bulkDeleteAssetCodesGroupDistinctSuccess = createAction(
  '[Common] Bulk Delete Asset Codes Group Distinct Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteAssetCodesGroupDistinctError = createAction(
  '[Common] Bulk Delete Asset Codes Group Distinct Error',
  props<{ error: any }>()
)

///////// LccaPeriodical /////////
export const findLccaPeriodicals = createAction(
  '[Common] Find LCCA Periodicals',
  props<{ page: number, size: number, keywords: string }>()
)
export const findLccaPeriodicalsSuccess = createAction(
  '[Common] Find LCCA Periodicals Success',
  props<{ lccaPeriodicals: Result<CatalogLccaPeriodicalsResponse> }>()
)
export const findLccaPeriodicalsError = createAction(
  '[Common] Find LCCA Periodicals Error',
  props<{ error: any }>()
)
export const createLccaPeriodical = createAction(
  '[Common] Create LCCA Periodical',
  props<{ lccaPeriodical: CatalogLccaPeriodicalsCreate }>()
)
export const createLccaPeriodicalSuccess = createAction(
  '[Common] Create LCCA Periodical Success',
  props<{ lccaPeriodical: CatalogLccaPeriodicalsResponse }>()
)
export const createLccaPeriodicalError = createAction(
  '[Common] Create LCCA Periodical Error',
  props<{ error: any }>()
)
export const updateLccaPeriodical = createAction(
  '[Common] Update LCCA Periodical',
  props<{ id: number, lccaPeriodical: CatalogLccaPeriodicalsUpdate }>()
)
export const updateLccaPeriodicalSuccess = createAction(
  '[Common] Update LCCA Periodical Success',
  props<{ lccaPeriodical: CatalogLccaPeriodicalsResponse }>()
)
export const updateLccaPeriodicalError = createAction(
  '[Common] Update LCCA Periodical Error',
  props<{ error: any }>()
)
export const deleteLccaPeriodical = createAction(
  '[Common] Delete LCCA Periodical',
  props<{ id: number }>()
)
export const deleteLccaPeriodicalSuccess = createAction(
  '[Common] Delete LCCA Periodical Success',
  props<{ id: number }>()
)
export const deleteLccaPeriodicalError = createAction(
  '[Common] Delete LCCA Periodical Error',
  props<{ error: any }>()
)
export const bulkDeleteLccaPeriodicals = createAction(
  '[Common] Bulk Delete LCCA Periodicals',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccaPeriodicalsSuccess = createAction(
  '[Common] Bulk Delete LCCA Periodicals Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccaPeriodicalsError = createAction(
  '[Common] Bulk Delete LCCA Periodicals Error',
  props<{ error: any }>()
)

///////// LccaTrigger /////////
export const findLccaTriggers = createAction(
  '[Common] Find LCCA Triggers',
  props<{ page: number, size: number, keywords: string }>()
)
export const findLccaTriggersSuccess = createAction(
  '[Common] Find LCCA Triggers Success',
  props<{ lccaTriggers: Result<CatalogLccaTriggerResponse> }>()
)
export const findLccaTriggersError = createAction(
  '[Common] Find LCCA Triggers Error',
  props<{ error: any }>()
)
export const createLccaTrigger = createAction(
  '[Common] Create LCCA Trigger',
  props<{ lccaTrigger: CatalogLccaTriggerCreate }>()
)
export const createLccaTriggerSuccess = createAction(
  '[Common] Create LCCA Trigger Success',
  props<{ lccaTrigger: CatalogLccaTriggerResponse }>()
)
export const createLccaTriggerError = createAction(
  '[Common] Create LCCA Trigger Error',
  props<{ error: any }>()
)
export const updateLccaTrigger = createAction(
  '[Common] Update LCCA Trigger',
  props<{ id: number, lccaTrigger: CatalogLccaTriggerUpdate }>()
)
export const updateLccaTriggerSuccess = createAction(
  '[Common] Update LCCA Trigger Success',
  props<{ lccaTrigger: CatalogLccaTriggerResponse }>()
)
export const updateLccaTriggerError = createAction(
  '[Common] Update LCCA Trigger Error',
  props<{ error: any }>()
)
export const deleteLccaTrigger = createAction(
  '[Common] Delete LCCA Trigger',
  props<{ id: number }>()
)
export const deleteLccaTriggerSuccess = createAction(
  '[Common] Delete LCCA Trigger Success',
  props<{ id: number }>()
)
export const deleteLccaTriggerError = createAction(
  '[Common] Delete LCCA Trigger Error',
  props<{ error: any }>()
)
export const bulkDeleteLccaTriggers = createAction(
  '[Common] Bulk Delete LCCA Triggers',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccaTriggersSuccess = createAction(
  '[Common] Bulk Delete LCCA Triggers Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccaTriggersError = createAction(
  '[Common] Bulk Delete LCCA Triggers Error',
  props<{ error: any }>()
)

///////// LccaType /////////
export const findLccaTypes = createAction(
  '[Common] Find LCCA Types',
  props<{ page: number, size: number, keywords: string }>()
)
export const findLccaTypesSuccess = createAction(
  '[Common] Find LCCA Types Success',
  props<{ lccaTypes: Result<CatalogLccaTypeResponse> }>()
)
export const findLccaTypesError = createAction(
  '[Common] Find LCCA Types Error',
  props<{ error: any }>()
)
export const createLccaType = createAction(
  '[Common] Create LCCA Type',
  props<{ lccaType: CatalogLccaTypeCreate }>()
)
export const createLccaTypeSuccess = createAction(
  '[Common] Create LCCA Type Success',
  props<{ lccaType: CatalogLccaTypeResponse }>()
)
export const createLccaTypeError = createAction(
  '[Common] Create LCCA Type Error',
  props<{ error: any }>()
)
export const updateLccaType = createAction(
  '[Common] Update LCCA Type',
  props<{ id: number, lccaType: CatalogLccaTypeUpdate }>()
)
export const updateLccaTypeSuccess = createAction(
  '[Common] Update LCCA Type Success',
  props<{ lccaType: CatalogLccaTypeResponse }>()
)
export const updateLccaTypeError = createAction(
  '[Common] Update LCCA Type Error',
  props<{ error: any }>()
)
export const deleteLccaType = createAction(
  '[Common] Delete LCCA Type',
  props<{ id: number }>()
)
export const deleteLccaTypeSuccess = createAction(
  '[Common] Delete LCCA Type Success',
  props<{ id: number }>()
)
export const deleteLccaTypeError = createAction(
  '[Common] Delete LCCA Type Error',
  props<{ error: any }>()
)
export const bulkDeleteLccaTypes = createAction(
  '[Common] Bulk Delete LCCA Types',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccaTypesSuccess = createAction(
  '[Common] Bulk Delete LCCA Types Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccaTypesError = createAction(
  '[Common] Bulk Delete LCCA Types Error',
  props<{ error: any }>()
)

///////// LccaUnit /////////
export const findLccaUnits = createAction(
  '[Common] Find LCCA Units',
  props<{ page: number, size: number, keywords: string }>()
)
export const findLccaUnitsSuccess = createAction(
  '[Common] Find LCCA Units Success',
  props<{ lccaUnits: Result<CatalogLccaUnitResponse> }>()
)
export const findLccaUnitsError = createAction(
  '[Common] Find LCCA Units Error',
  props<{ error: any }>()
)
export const createLccaUnit = createAction(
  '[Common] Create LCCA Unit',
  props<{ lccaUnit: CatalogLccaUnitCreate }>()
)
export const createLccaUnitSuccess = createAction(
  '[Common] Create LCCA Unit Success',
  props<{ lccaUnit: CatalogLccaUnitResponse }>()
)
export const createLccaUnitError = createAction(
  '[Common] Create LCCA Unit Error',
  props<{ error: any }>()
)
export const updateLccaUnit = createAction(
  '[Common] Update LCCA Unit',
  props<{ id: number, lccaUnit: CatalogLccaUnitUpdate }>()
)
export const updateLccaUnitSuccess = createAction(
  '[Common] Update LCCA Unit Success',
  props<{ lccaUnit: CatalogLccaUnitResponse }>()
)
export const updateLccaUnitError = createAction(
  '[Common] Update LCCA Unit Error',
  props<{ error: any }>()
)
export const deleteLccaUnit = createAction(
  '[Common] Delete LCCA Unit',
  props<{ id: number }>()
)
export const deleteLccaUnitSuccess = createAction(
  '[Common] Delete LCCA Unit Success',
  props<{ id: number }>()
)
export const deleteLccaUnitError = createAction(
  '[Common] Delete LCCA Unit Error',
  props<{ error: any }>()
)
export const bulkDeleteLccaUnits = createAction(
  '[Common] Bulk Delete LCCA Units',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccaUnitsSuccess = createAction(
  '[Common] Bulk Delete LCCA Units Success',
  props<{ ids: number[] }>()
)
export const bulkDeleteLccaUnitsError = createAction(
  '[Common] Bulk Delete LCCA Units Error',
  props<{ error: any }>()
)